var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"molecule-content-slider-brochure"},[_c('div',{ref:"carousel",staticClass:"owl-carousel owl-theme"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }